/*
=========================================================
* Material Kit 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { FC, ReactNode, forwardRef, useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Divider from "@mui/material/Divider";
import Slide from "@mui/material/Slide";

// @mui icons
import CloseIcon from "@mui/icons-material/Close";

// Material Kit 2 PRO React components
import MDBox from "../MDBox";
import MDButton from "../MDButton";
import MDTypography from "../MDTypography";
import MDModalRoot from "./MDModalRoot";
import { useMaterialUIController } from "../../context";

interface Props {
    open: boolean;
    onClose: Function;
    [key: string]: any;
    children: ReactNode;
    title: ReactNode | string;
    footer?: ReactNode | null;
    maxWidth?: string;
    width?: string;
};

const SimpleModal: FC<Props | any> = ({open, onClose, children, title, footer, maxWidth, width}) => {
    const bgColor = "white";
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    return (
        <MDModalRoot
            open={open}
            onClose={onClose}
            sx={{ display: "grid", placeItems: "center" }}
            style={{overflowY: "auto"}}
            ownerState={{bgColor, darkMode}}
        >
            <Slide direction="down" in={open} timeout={500}>
                <MDBox
                    position="relative"
                    maxWidth={maxWidth}
                    display="flex"
                    flexDirection="column"
                    borderRadius="xl"
                    shadow="xl"
                    width={width}
                    className="mui-modal-container"
                >
                    <MDBox display="flex" justifyContent="space-between" p={2}>
                        <MDTypography variant="h5">{title}</MDTypography>
                        <CloseIcon fontSize="medium" sx={{ cursor: "pointer" }} onClick={onClose} />
                    </MDBox>
                    <Divider sx={{ my: 0 }} />
                    <MDBox p={2}>
                        {children}
                    </MDBox>
                    <Divider sx={{ my: 0 }} />
                    {
                        footer ?
                            <MDBox display="flex" justifyContent="space-between" p={1.5}>
                                {footer}
                            </MDBox>
                        :
                            null
                    }
                </MDBox>
            </Slide>
        </MDModalRoot>
    );
}

SimpleModal.defaultProps = {
    maxWidth: "500px",
    open: false,
    width: "350px"
}

export default SimpleModal;
